










import {Component, Emit, Vue} from 'vue-property-decorator';
import contentsModule from '@/model/store/modules/contents-module';
import userModule from '@/model/store/modules/user-module';
import appModule from '@/model/store/modules/app-module';
import viewerService from '@/model/services/viewer-service';
import _ from 'lodash';

@Component({
  components: {}
})
export default class LeftViewer extends Vue {
  /** Data **/

  /** States **/

  /** Mutations **/

  /** Refs **/

  /** Methods **/

  // エラーの伝搬
  @Emit('error')
  private errorPropagation(err: Error): Error {
    console.log(err);
    return err;
  }

  /** LifeCycle **/

  private async mounted() {

  }

}
